import React from 'react'
import { compose } from 'recompose'
import { Dropdown } from 'semantic-ui-react'

const MultiSelectInput = (props) => {
  const { label, placeHolder, input, require, editable, loading,
    allowAdditions, onAddNewItem, specialOnChange, options, meta: { touched, error } } = props
  return (
    <div className='fieldRow'>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`fieldInput ${editable!==false?'editableSelectInput':'disableSelectInput'}`}>
        <Dropdown
          name={input.name}
          fluid
          search
          selection
          disabled={editable === false}
          placeholder={placeHolder}
          additionPosition='bottom'
          error={touched && error}
          defaultValue={input.value}
          options={options}
          value={input.value}
          multiple
          allowAdditions={allowAdditions !== undefined ? allowAdditions : false}
          loading={loading !== undefined ? loading : false}
          onChange={(event, data) => {
            input.onChange(data.value)
            if (specialOnChange) {
              specialOnChange(data.value)
            }
          }}
          onAddItem={(event, data) => {
            if(onAddNewItem){
              onAddNewItem(data.value)
            }
          }}
        />
      </div>
    </div>
  )
}

export default compose()(MultiSelectInput)
